import { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';

import { Link, useLocation, useParams } from "react-router-dom";
import loading from "../../../assets/images/loading.gif"
import Modal from "react-modal"
import PdfGeneratorConsCommercialInvoice from "../../pdftemplates/generateConsolidatedCommercialInvoice";
import PdfGeneratorConsPackingList from "../../pdftemplates/generateConsolidatedPackingList";
import PdfGeneratedHandoffDocument from "../../pdftemplates/generateHandOffDocument";
import { makeGetRequest } from "../../../request";
import Layout from "../../Layout";
import { customStyles, formatDateTime, getDocumentNameWithoutEndingWithLCA, handleDownloadForShippingDocuments, handlePreviewForShippingDocuments } from "helpers";
import { useSelector } from "react-redux";

const ShippingDocumentsDetail =  () => {
    const param = useParams()
    const location = useLocation()
    const statusAfterNavigation = location.state as { status: number };
    const pageContext: any = useSelector((state: any)=> state.pageContext.value)
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState<Record <string, any>>([])
    const [isShowInvoice, setIsShowInvoice] = useState(false)
    const [isShowPackingList, setIsShowPackingList] = useState(false)
    const [isShowHandoffDocument, setIsShowHandoffDocument] = useState(false)
    const FreightForwarderShippingDocuments = [
        "Draft_Master_Bill_Of_Lading_Or_Air_Way_Bill",
        "Draft_House_Bill_Of_Lading_Or_Air_Way_Bill",
        "Draft_Combined_Certificate_Value_Origin",
        "Master_Bill_Of_Lading_Or_Air_Way_Bill",
        "House_Bill_Of_Lading_Or_Air_Way_Bill",
        "Combined_Certificate_Value_Origin",
    ]

    const LCAShippingDocuments = [
        "FinalDutyAssessmentDocument",
        "StandardOrganisationOfNigeriaConformityAssessmentProgramme",
        "PreArrivalAssessmentReport",
        "DemandNotice",
        "DemandNoticePaymentReceipt",
        "SingleGoodsDeclarationForm",
        "SingleGoodsDeclarationDetailOfValuationNote",
        "ExchangeControl",
        "FormM",
        "ShippingAndTerminalCompanyReceipts",
        "ProofOfDelivery",
        "NAFDACReleaseNote",
        "AcknowledgementLetter",
        "ExitNote",
        "ContainerRefundDocuments",
        "AgentDeliveryWayBill",
        "PreReleaseGrantedByCustom"
    ];

    // Retrives the last occurence that matches the document name
    // get color and icon
    const getDocumentStatusSettings = (shipment: any, documentName: string) => {
        const status = shipment?.shippingDocumentAttachments?.reduce(
        (prev: any, curr: any) => {
            return curr.documentName === documentName ? curr : prev;
        },
        null
        )?.isApproved;

        switch (status) {
            case true:
                return {
                    color: "text-green",
                    icon: "check"
                };
            case false:
                return {
                    color: "text-red",
                    icon: "close"
                };
            case null:
                return {
                    color: "text-yellow",
                    icon: "hourglass_top"
                };
            default:
                return {
                    color: "text-grey",
                    icon: "circle"
                };
        }
    };

    const getShippingDocument = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getShippingDocumentById",
            id: param.id
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setData(res)
            })
            .catch((error:any) => 
                toast.error(error.errorMessage)
            );
    }

    const handleDownloadClick = async (shipment: any, documentName: string, title: string) => {
        // Set isLoading to true when the download process starts
        setIsLoading(true);
    
        // Call the function to handle the document download
        const result = await handleDownloadForShippingDocuments(shipment, documentName, title);
    
        // Set isLoading to false based on the result of the download operation
        setIsLoading(result);
    };

    const handlePreviewClick = async (shipment: any, documentName: string) => {
        // Set isLoading to true when the download process starts
        setIsLoading(true);
    
        // Call the function to handle the document download
        const result = await handlePreviewForShippingDocuments(shipment, documentName);
    
        // Set isLoading to false based on the result of the download operation
        setIsLoading(result);
    };
    
    /**
     * Retrives the last occurence that matches the document name
     *
     * @param {any} shipment - The shipment object containing the document attachments.
     * @param {string} documentName - The name of the document to retrieve the blob storage name for.
     * @return {string | null} The document blob storage name if found, otherwise null.
     */
    const getDocumentBlobStorageName = (shipment: any, documentName: string) => {
        return shipment?.shippingDocumentAttachments?.reduce((prev: any, curr: any) => {
          return curr.documentName === documentName ? curr : prev;
        }, null)?.documentBlobStorageName;
    };

    const getDocumentUploadDate = (shipment:any, documentName: string) => {
        return shipment?.shippingDocumentAttachments?.find((attachment: any) => attachment.documentName === documentName)?.createdDate
    }

    useEffect(() => {
        getShippingDocument() // eslint-disable-next-line
    }, [])

    const page = "Shipping Documents"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    
                    <div className="main-inner">                  
                        <div className="detail-top-section">
                            <Link  to={
                                pageContext?.url
                                ? pageContext.url
                                : "/portofficer/shippingdocuments"
                            }
                            state={{ status: statusAfterNavigation?.status, originName: "shipping" }}
                            className="actions">
                                <p><span className="material-symbols-rounded">arrow_back</span> Back to Shipping Documents</p>
                            </Link>
                              
                            <div className="tab">
                                <div className="tab-item active">
                                    <span className="material-symbols-rounded">visibility</span>
                                    <p>Preview Shipping Documents</p>
                                </div>
                            </div>                      
                        </div>
                    </div>   

                    <div className="main-inner mt-1" style={{minHeight: "100vh", padding: "16px", boxSizing: "border-box"}}> 
                        <div className="accordion">
                            <div className={`header d-flex ${isShowInvoice ? 'active' : ''}`} onClick={() => setIsShowInvoice(!isShowInvoice)}>
                                <div className="d-flex">
                                    <span className="material-symbols-rounded">{isShowInvoice ? "expand_more" : "chevron_right"}</span>
                                    <span>Consolidated Commercial Invoice</span>
                                </div>
                                <p className="small-text m-0">Created: {formatDateTime(data?.createdDate)}</p>
                            </div>
                            {isShowInvoice && <div className="body">
                                <PdfGeneratorConsCommercialInvoice key="1" data={data?.consolidatedPackingList} consolidatedInvoiceNumber={data?.consolidatedCommercialInvoiceNumber} />
                            </div>}
                        </div>    

                        <div className="accordion mt-1">
                            <div className={`header d-flex ${isShowPackingList ? 'active' : ''}`} onClick={() => setIsShowPackingList(!isShowPackingList)}>
                                <div className="d-flex">
                                    <span className="material-symbols-rounded">{isShowPackingList ? "expand_more" : "chevron_right"}</span>
                                    <span>Consolidated Packing List</span>
                                </div>
                                <p className="small-text m-0">Created: {formatDateTime(data?.createdDate)}</p>
                            </div>
                            {isShowPackingList && <div className="body">
                                <PdfGeneratorConsPackingList key="2" data={data?.consolidatedPackingList} />
                            </div>}
                        </div>

                        <div className="d-flex file-input-container mt-1">
                            <div className="d-flex-2" style={{alignItems: "start"}}>
                                {/* This is because at this point the document must have been approved */}
                                <span className={"material-symbols-outlined text-green f-16"}>check</span>
                                <span className={!getDocumentBlobStorageName(data, "Draft_Master_Bill_Of_Lading_Or_Air_Way_Bill") ? "disabled" : ""}>
                                    Draft Master Bill Of Lading/Air Way Bill
                                    <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "Draft_Master_Bill_Of_Lading_Or_Air_Way_Bill"))}</p>
                                </span> 
                            </div>
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "Draft_Master_Bill_Of_Lading_Or_Air_Way_Bill")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "Draft_Master_Bill_Of_Lading_Or_Air_Way_Bill")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }  
                                <button className='actions blue' 
                                    disabled={!getDocumentBlobStorageName(data, "Draft_Master_Bill_Of_Lading_Or_Air_Way_Bill")} 
                                    onClick={() => handleDownloadClick(data, "Draft_Master_Bill_Of_Lading_Or_Air_Way_Bill", "Draft_Master_Bill_Of_Lading_Or_Air_Way_Bill_")}>
                                        <span className="material-symbols-rounded">download</span>
                                        <span>Download</span>
                                </button>
                            </div>
                        </div>   

                        <div className="d-flex file-input-container mt-1">
                            <div className="d-flex-2" style={{alignItems: "start"}}>
                                {/* This is because at this point the document must have been approved */}
                                <span className={"material-symbols-outlined text-green f-16"}>check</span>
                                <span className={!getDocumentBlobStorageName(data, "Draft_House_Bill_Of_Lading_Or_Air_Way_Bill") ? "disabled" : ""}>
                                    Draft House Bill Of Lading/Air Way Bill
                                    <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "Draft_House_Bill_Of_Lading_Or_Air_Way_Bill"))}</p>
                                </span> 
                            </div>
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "Draft_House_Bill_Of_Lading_Or_Air_Way_Bill")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "Draft_House_Bill_Of_Lading_Or_Air_Way_Bill")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }  
                                <button className='actions blue' 
                                    disabled={!getDocumentBlobStorageName(data, "Draft_House_Bill_Of_Lading_Or_Air_Way_Bill")} 
                                    onClick={() => handleDownloadClick(data, "Draft_House_Bill_Of_Lading_Or_Air_Way_Bill", "Draft_House_Bill_Of_Lading_Or_Air_Way_Bill_")}>
                                        <span className="material-symbols-rounded">download</span>
                                        <span>Download</span>
                                </button>
                            </div>
                        </div>   
                        
                        <div className="d-flex file-input-container mt-1">
                            <div className="d-flex-2" style={{alignItems: "start"}}>
                                {/* This is because at this point the document must have been approved */}
                                <span className={"material-symbols-outlined text-green f-16"}>check</span>
                                <span className={!getDocumentBlobStorageName(data, "Draft_Combined_Certificate_Value_Origin") ? "disabled" : ""}>
                                    Draft Combined Certificate Value Origin (CCVO)
                                    <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "Draft_Combined_Certificate_Value_Origin"))}</p>
                                </span>
                            </div>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "Draft_Combined_Certificate_Value_Origin")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "Draft_Combined_Certificate_Value_Origin")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                <button className='actions blue'
                                    disabled={!getDocumentBlobStorageName(data, "Draft_Combined_Certificate_Value_Origin")} 
                                    onClick={() => handleDownloadClick(data, "Draft_Combined_Certificate_Value_Origin", "Draft_Combined_Certificate_Value_Origin_")}>
                                        <span className="material-symbols-rounded">download</span>
                                        <span>Download</span>
                                </button>
                            </div>
                        </div> 

                        {/* OTHER DRAFT DOCUMENTS */}
                        {
                            data?.shippingDocumentAttachments
                            ?.filter(
                                (record: any) => !FreightForwarderShippingDocuments.includes(record.documentName) && record.documentName.startsWith("Draft") && !LCAShippingDocuments.includes(record.docuemntName)
                            )
                            ?.map((attachment: any, index: number) => {
                                return (
                                        <div className="d-flex file-input-container mt-1" key={index}>
                                            <div className="d-flex-2" style={{alignItems: "start"}}>     
                                                {/* This is because at this point the document must have been approved */}
                                <span className={"material-symbols-outlined text-green f-16"}>check</span>
                                                <span className={!getDocumentBlobStorageName(data, attachment.documentName) ? "disabled" : ""}>
                                                    {attachment.documentName?.replaceAll("_", " ")}
                                                    <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, attachment.documentName))}</p>
                                                </span>
                                            </div> 
                                            <div className="d-flex">
                                                {getDocumentBlobStorageName(data, attachment.documentName)?.split('.')[1] === "pdf"
                                                    &&<button className='actions blue mr-1'
                                                        onClick={() => handlePreviewClick(data, attachment.documentName)}>
                                                            <span className="material-symbols-rounded">preview</span>
                                                            <span>Preview</span>
                                                    </button> }
                                                <button className='actions blue' 
                                                    disabled={!getDocumentBlobStorageName(data, attachment.documentName)} 
                                                    onClick={() => handleDownloadClick(data, attachment.documentName, `${attachment.documentName}_`)}>
                                                        <span className="material-symbols-rounded">download</span>
                                                        <span>Download</span>
                                                </button>
                                            </div>
                                        </div>
                                )
                            })
                        }

                        <div className="d-flex file-input-container mt-1">
                            <div className="d-flex-2" style={{alignItems: "start"}}>
                                <span className={`material-symbols-outlined ${getDocumentStatusSettings(data, "Master_Bill_Of_Lading_Or_Air_Way_Bill").color} f-16`}>{getDocumentStatusSettings(data, "Master_Bill_Of_Lading_Or_Air_Way_Bill").icon}</span>
                                <span className={!getDocumentBlobStorageName(data, "Master_Bill_Of_Lading_Or_Air_Way_Bill") ? "disabled" : ""}>
                                    Master Bill Of Lading/Air Way Bill
                                    <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "Master_Bill_Of_Lading_Or_Air_Way_Bill"))}</p>
                                </span> 
                            </div>
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "Master_Bill_Of_Lading_Or_Air_Way_Bill")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "Master_Bill_Of_Lading_Or_Air_Way_Bill")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }  
                                <button className='actions blue' 
                                    disabled={!getDocumentBlobStorageName(data, "Master_Bill_Of_Lading_Or_Air_Way_Bill")} 
                                    onClick={() => handleDownloadClick(data, "Master_Bill_Of_Lading_Or_Air_Way_Bill", "Master_Bill_Of_Lading_Or_Air_Way_Bill_")}>
                                        <span className="material-symbols-rounded">download</span>
                                        <span>Download</span>
                                </button>
                            </div>
                        </div>   

                        <div className="d-flex file-input-container mt-1">
                            <div className="d-flex-2" style={{alignItems: "start"}}>
                                <span className={`material-symbols-outlined ${getDocumentStatusSettings(data, "House_Bill_Of_Lading_Or_Air_Way_Bill").color} f-16`}>{getDocumentStatusSettings(data, "House_Bill_Of_Lading_Or_Air_Way_Bill").icon}</span>
                                <span className={!getDocumentBlobStorageName(data, "House_Bill_Of_Lading_Or_Air_Way_Bill") ? "disabled" : ""}>
                                    House Bill Of Lading/Air Way Bill
                                    <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "House_Bill_Of_Lading_Or_Air_Way_Bill"))}</p>
                                </span> 
                            </div>
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "House_Bill_Of_Lading_Or_Air_Way_Bill")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "House_Bill_Of_Lading_Or_Air_Way_Bill")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }  
                                <button className='actions blue' 
                                    disabled={!getDocumentBlobStorageName(data, "House_Bill_Of_Lading_Or_Air_Way_Bill")} 
                                    onClick={() => handleDownloadClick(data, "House_Bill_Of_Lading_Or_Air_Way_Bill", "House_Bill_Of_Lading_Or_Air_Way_Bill_")}>
                                        <span className="material-symbols-rounded">download</span>
                                        <span>Download</span>
                                </button>
                            </div>
                        </div>   

                        <div className="d-flex file-input-container mt-1">
                            <div className="d-flex-2" style={{alignItems: "start"}}>
                                <span className={`material-symbols-outlined ${getDocumentStatusSettings(data, "Combined_Certificate_Value_Origin").color} f-16`}>{getDocumentStatusSettings(data, "Combined_Certificate_Value_Origin").icon}</span>
                                <span className={!getDocumentBlobStorageName(data, "Combined_Certificate_Value_Origin") ? "disabled" : ""}>
                                    Combined Certificate Value Origin (CCVO)
                                    <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "Combined_Certificate_Value_Origin"))}</p>
                                </span>
                            </div>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "Combined_Certificate_Value_Origin")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "Combined_Certificate_Value_Origin")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                <button className='actions blue'
                                    disabled={!getDocumentBlobStorageName(data, "Combined_Certificate_Value_Origin")} 
                                    onClick={() => handleDownloadClick(data, "Combined_Certificate_Value_Origin", "Combined_Certificate_Value_Origin_")}>
                                        <span className="material-symbols-rounded">download</span>
                                        <span>Download</span>
                                </button>
                            </div>
                        </div> 

                        {/* OTHER FINAL DOCUMENTS */}
                        {
                            data?.shippingDocumentAttachments
                            ?.filter(
                                (record: any) => !FreightForwarderShippingDocuments.includes(record.documentName) 
                                                    && !record.documentName.startsWith("Draft") 
                                                    && !record.documentName.endsWith("LCA") 
                                                    && !LCAShippingDocuments.includes(record.documentName)
                            )
                            ?.map((attachment: any, index: number) => {
                                return (
                                        <div className="d-flex file-input-container mt-1" key={index}>
                                            <div className="d-flex-2" style={{alignItems: "start"}}>
                                                <span className={`material-symbols-outlined ${getDocumentStatusSettings(data, attachment.documentName).color} f-16`}>{getDocumentStatusSettings(data, attachment.documentName).icon}</span>
                                                <span className={!getDocumentBlobStorageName(data, attachment.documentName) ? "disabled" : ""}>
                                                    {attachment.documentName?.replaceAll("_", " ")}
                                                    <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, attachment.documentName))}</p>
                                                </span>
                                            </div> 
                                            <div className="d-flex">
                                                {getDocumentBlobStorageName(data, attachment.documentName)?.split('.')[1] === "pdf"
                                                    &&<button className='actions blue mr-1'
                                                        onClick={() => handlePreviewClick(data, attachment.documentName)}>
                                                            <span className="material-symbols-rounded">preview</span>
                                                            <span>Preview</span>
                                                    </button> }
                                                <button className='actions blue' 
                                                    disabled={!getDocumentBlobStorageName(data, attachment.documentName)} 
                                                    onClick={() => handleDownloadClick(data, attachment.documentName, `${attachment.documentName}_`)}>
                                                        <span className="material-symbols-rounded">download</span>
                                                        <span>Download</span>
                                                </button>
                                            </div>
                                        </div>
                                )
                            })
                        }

                        {getDocumentBlobStorageName(data, "StandardOrganisationOfNigeriaConformityAssessmentProgramme") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "StandardOrganisationOfNigeriaConformityAssessmentProgramme") ? "disabled" : ""}>
                                SONCAP
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "StandardOrganisationOfNigeriaConformityAssessmentProgramme"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "StandardOrganisationOfNigeriaConformityAssessmentProgramme")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "StandardOrganisationOfNigeriaConformityAssessmentProgramme")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "StandardOrganisationOfNigeriaConformityAssessmentProgramme")} 
                                        onClick={() => handleDownloadClick(data, "StandardOrganisationOfNigeriaConformityAssessmentProgramme", "Standard_Organisation_Of_Nigeria_Conformity_Assessment_Programme_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}

                        {getDocumentBlobStorageName(data, "FormM") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "FormM") ? "disabled" : ""}>
                                Form M
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "FormM"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "FormM")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "FormM")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "FormM")} 
                                        onClick={() => handleDownloadClick(data, "FormM", "FormM_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}

                        {getDocumentBlobStorageName(data, "AcknowledgementLetter") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "AcknowledgementLetter") ? "disabled" : ""}>
                                Acknowledgement Letter
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "AcknowledgementLetter"))}</p>
                            </span> 
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "AcknowledgementLetter")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "AcknowledgementLetter")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> } 
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "AcknowledgementLetter")} 
                                        onClick={() => handleDownloadClick(data, "AcknowledgementLetter", "Acknowledgement_Letter_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}

                        {getDocumentBlobStorageName(data, "AgentDeliveryWayBill") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "AgentDeliveryWayBill") ? "disabled" : ""}>
                                Agent Delivery Way Bill
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "AgentDeliveryWayBill"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "AgentDeliveryWayBill")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "AgentDeliveryWayBill")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "AgentDeliveryWayBill")} 
                                        onClick={() => handleDownloadClick(data, "AgentDeliveryWayBill", "Agent_Delivery_Way_Bill_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}

                        {getDocumentBlobStorageName(data, "PreReleaseGrantedByCustom") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "PreReleaseGrantedByCustom") ? "disabled" : ""}>
                                Pre Release Granted By Custom
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "PreReleaseGrantedByCustom"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "PreReleaseGrantedByCustom")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "PreReleaseGrantedByCustom")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "PreReleaseGrantedByCustom")} 
                                        onClick={() => handleDownloadClick(data, "PreReleaseGrantedByCustom", "Pre_Release_Granted_By_Custom_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}

                        {/* Other shipping documents */}
                        {
                            data?.shippingDocumentAttachments
                            ?.filter(
                                (record: any) => !FreightForwarderShippingDocuments.includes(record.documentName) 
                                                    && !record.documentName.startsWith("Draft") 
                                                    && record.documentName.endsWith("LCA") 
                                                    && !LCAShippingDocuments.includes(record.documentName)
                            )
                            ?.map((attachment: any, index: number) => {
                                return (
                                        <div className="d-flex file-input-container mt-1" key={index}>
                                            <div className="d-flex-2" style={{alignItems: "start"}}>
                                                <span className={`material-symbols-outlined ${getDocumentStatusSettings(data, attachment.documentName).color} f-16`}>{getDocumentStatusSettings(data, attachment.documentName).icon}</span>
                                                <span className={!getDocumentBlobStorageName(data, attachment.documentName) ? "disabled" : ""}>
                                                    {getDocumentNameWithoutEndingWithLCA(attachment.documentName)}
                                                    <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, attachment.documentName))}</p>
                                                </span>
                                            </div> 
                                            <div className="d-flex">
                                                {getDocumentBlobStorageName(data, attachment.documentName)?.split('.')[1] === "pdf"
                                                    &&<button className='actions blue mr-1'
                                                        onClick={() => handlePreviewClick(data, attachment.documentName)}>
                                                            <span className="material-symbols-rounded">preview</span>
                                                            <span>Preview</span>
                                                    </button> }
                                                <button className='actions blue' 
                                                    disabled={!getDocumentBlobStorageName(data, attachment.documentName)} 
                                                    onClick={() => handleDownloadClick(data, attachment.documentName, `${attachment.documentName}_`)}>
                                                        <span className="material-symbols-rounded">download</span>
                                                        <span>Download</span>
                                                </button>
                                            </div>
                                        </div>
                                )
                            })
                        }

                        {getDocumentBlobStorageName(data, "FinalDutyAssessmentDocument") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "FinalDutyAssessmentDocument") ? "disabled" : ""}>
                                Final Duty Assessment Document
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "FinalDutyAssessmentDocument"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "FinalDutyAssessmentDocument")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "FinalDutyAssessmentDocument")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "FinalDutyAssessmentDocument")} 
                                        onClick={() => handleDownloadClick(data, "FinalDutyAssessmentDocument", "Final_Duty_Assessment_Document_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div> }                        

                        {getDocumentBlobStorageName(data, "PreArrivalAssessmentReport") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "PreArrivalAssessmentReport") ? "disabled" : ""}>
                                Pre Arrival Assessment Report (PAAR)
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "PreArrivalAssessmentReport"))}</p>
                            </span> 
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "PreArrivalAssessmentReport")?.split('.')[1] === "pdf"
                                &&<button className='actions blue mr-1'
                                    onClick={() => handlePreviewClick(data, "PreArrivalAssessmentReport")}>
                                        <span className="material-symbols-rounded">preview</span>
                                        <span>Preview</span>
                                </button> }
                                <button className='actions blue'
                                    disabled={!getDocumentBlobStorageName(data, "PreArrivalAssessmentReport")} 
                                    onClick={() => handleDownloadClick(data, "PreArrivalAssessmentReport", "Pre_Arrival_Assessment_Report")}>
                                        <span className="material-symbols-rounded">download</span>
                                        <span>Download</span>
                                </button>
                            </div>
                        </div>} 

                        {getDocumentBlobStorageName(data, "DemandNotice") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "DemandNotice") ? "disabled" : ""}>
                                Demand Notice
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "DemandNotice"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "DemandNotice")?.split('.')[1] === "pdf"
                                &&<button className='actions blue mr-1'
                                    onClick={() => handlePreviewClick(data, "DemandNotice")}>
                                        <span className="material-symbols-rounded">preview</span>
                                        <span>Preview</span>
                                </button> }
                                <button className='actions blue'
                                    disabled={!getDocumentBlobStorageName(data, "DemandNotice")} 
                                    onClick={() => handleDownloadClick(data, "DemandNotice", "Demand_Note_")}>
                                        <span className="material-symbols-rounded">download</span>
                                        <span>Download</span>
                                </button>
                            </div>   
                        </div>}

                        {getDocumentBlobStorageName(data, "DemandNoticePaymentReceipt") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "DemandNoticePaymentReceipt") ? "disabled" : ""}>
                                Demand Notice Payment Receipt
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "DemandNoticePaymentReceipt"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "DemandNoticePaymentReceipt")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "DemandNoticePaymentReceipt")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "DemandNoticePaymentReceipt")} 
                                        onClick={() => handleDownloadClick(data, "DemandNoticePaymentReceipt", "Demand_Notice_Payment_Receipt_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>} 

                        {getDocumentBlobStorageName(data, "SingleGoodsDeclarationForm") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "SingleGoodsDeclarationForm") ? "disabled" : ""}>
                                SGD Form
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "SingleGoodsDeclarationForm"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "SingleGoodsDeclarationForm")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "SingleGoodsDeclarationForm")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "SingleGoodsDeclarationForm")} 
                                        onClick={() => handleDownloadClick(data, "SingleGoodsDeclarationForm", "Single_Goods_Declaration_Form_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>} 

                        {getDocumentBlobStorageName(data, "SingleGoodsDeclarationDetailOfValuationNote") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "SingleGoodsDeclarationDetailOfValuationNote") ? "disabled" : ""}>
                                SGD Detail Of Valuation Note
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "SingleGoodsDeclarationDetailOfValuationNote"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "SingleGoodsDeclarationDetailOfValuationNote")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "SingleGoodsDeclarationDetailOfValuationNote")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "SingleGoodsDeclarationDetailOfValuationNote")} 
                                        onClick={() => handleDownloadClick(data, "SingleGoodsDeclarationDetailOfValuationNote", "Single_Goods_Declaration_Detail_Of_Valuation_Note_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div> }

                        {getDocumentBlobStorageName(data, "ExchangeControl") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "ExchangeControl") ? "disabled" : ""}>
                                Exchange Control
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "ExchangeControl"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "ExchangeControl")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "ExchangeControl")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "ExchangeControl")} 
                                        onClick={() => handleDownloadClick(data, "ExchangeControl", "Exchange_Control_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div> }

                        {getDocumentBlobStorageName(data, "ShippingAndTerminalCompanyReceipts") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "ShippingAndTerminalCompanyReceipts") ? "disabled" : ""}>
                                Shipping And Terminal Company Receipts
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "ShippingAndTerminalCompanyReceipts"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "ShippingAndTerminalCompanyReceipts")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "ShippingAndTerminalCompanyReceipts")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "ShippingAndTerminalCompanyReceipts")} 
                                        onClick={() => handleDownloadClick(data, "ShippingAndTerminalCompanyReceipts", "Shipping_And_Terminal_Company_Receipts_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}

                        {getDocumentBlobStorageName(data, "ProofOfDelivery") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "ProofOfDelivery") ? "disabled" : ""}>
                                Proof Of Delivery
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "ProofOfDelivery"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "ProofOfDelivery")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "ProofOfDelivery")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "ProofOfDelivery")} 
                                        onClick={() => handleDownloadClick(data, "ProofOfDelivery", "Proof_Of_Delivery_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}

                        {getDocumentBlobStorageName(data, "NAFDACReleaseNote") && <div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "NAFDACReleaseNote") ? "disabled" : ""}>
                                NAFDAC Release Note
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "NAFDACReleaseNote"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "NAFDACReleaseNote")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "NAFDACReleaseNote")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "NAFDACReleaseNote")} 
                                        onClick={() => handleDownloadClick(data, "NAFDACReleaseNote", "NAFDAC_Release_Note_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}                        

                        {getDocumentBlobStorageName(data, "ExitNote") &&<div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "ExitNote") ? "disabled" : ""}>
                                Customs Exit Note
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "ExitNote"))}</p>
                            </span>  
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "ExitNote")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "ExitNote")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> }
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "ExitNote")} 
                                        onClick={() => handleDownloadClick(data, "ExitNote", "Exit_Note_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}

                        {(data?.portOfficerStatus === 2 && data?.handOffDocumentId) &&
                        <div className="accordion mt-1">
                            <div className={`header d-flex ${isShowHandoffDocument ? 'active' : ''}`} onClick={() => setIsShowHandoffDocument(!isShowHandoffDocument)}>
                                <div className="d-flex">
                                    <span className="material-symbols-rounded">{isShowHandoffDocument ? "expand_more" : "chevron_right"}</span>
                                    <span>Handoff Document</span>
                                </div>
                                {/* <p className="small-text m-0">Created: {formatDateTime(data?.handOffDocument?.createdDate)}</p> */}
                            </div>
                            {isShowHandoffDocument && <div className="body">
                                <PdfGeneratedHandoffDocument shippingDocument={data} />
                            </div>}
                        </div>}

                        {getDocumentBlobStorageName(data, "ContainerRefundDocuments") &&<div className="d-flex file-input-container mt-1">
                            <span className={!getDocumentBlobStorageName(data, "ContainerRefundDocuments") ? "disabled" : ""}>
                                Container Refund Documents
                                <p className="small-text m-0 mt-1">Uploaded: {formatDateTime(getDocumentUploadDate(data, "ContainerRefundDocuments"))}</p>
                            </span> 
                            <div className="d-flex">
                                {getDocumentBlobStorageName(data, "ContainerRefundDocuments")?.split('.')[1] === "pdf"
                                    &&<button className='actions blue mr-1'
                                        onClick={() => handlePreviewClick(data, "ContainerRefundDocuments")}>
                                            <span className="material-symbols-rounded">preview</span>
                                            <span>Preview</span>
                                    </button> } 
                                    <button className='actions blue'
                                        disabled={!getDocumentBlobStorageName(data, "ContainerRefundDocuments")} 
                                        onClick={() => handleDownloadClick(data, "ContainerRefundDocuments", "Container_Refund_Documents_")}>
                                            <span className="material-symbols-rounded">download</span>
                                            <span>Download</span>
                                    </button>
                            </div>
                        </div>}
                    </div>
                </div>
                <Modal isOpen={isLoading} style={customStyles} className="modal modal-sm" ariaHideApp={false}>
                    <div className="loader">
                        <img src={loading} alt="loading" />
                        <p>Loading data...</p>
                    </div>
                </Modal> 
                <ToastContainer />
            </div>
            <ToastContainer />
        </Layout>
    )
}

export default ShippingDocumentsDetail